import React, { useEffect, useState } from "react";
import useFetcher from "../../../hooks/useFetcher";
import { fetchMessageTicketing } from "../../../services/messageTicketingService";
import Chat from "./Chat";

const ChatBox = ({
  ticketId,
  ticket,
  conversationSelectedId,
  isNewConversation,
  isReplyMessage,
  setIsReplyMessage,
  handleFilesChange,
  changeReplyMessage,
  handleReloadTicket,
  isAudit,
}) => {
  const [conversation, isLoadingConversation] = useFetcher(fetchMessageTicketing, [ticketId, conversationSelectedId]);
  const [messages, setMessages] = useState([]);
  const lastMessageId = !isLoadingConversation ? conversation.lastMessageId : null;
  const conversationSubject = !isLoadingConversation ? conversation.subject : null;
  const [isConversationRoot, setIsConversationRoot] = useState(false);

  const addNewMessage = (newMessage) => {
    messages.push(newMessage);
  };
  const handleReload = () => {
    handleReloadTicket();
  };
  useEffect(() => {
    if (conversation.messages) {
      setMessages(conversation.messages);
      setIsConversationRoot(conversation.isRoot);
    }
  }, [JSON.stringify(conversation)]);

  return (
    <>
      {!isNewConversation && messages.length > 0 && (
        <Chat
          ticketId={ticketId}
          ticket={ticket}
          messages={messages}
          setMessages={setMessages}
          lastMessageId={lastMessageId}
          conversationSubject={conversationSubject}
          conversation={conversation}
          isConversationRoot={isConversationRoot}
          addNewMessage={addNewMessage}
          changeReplyMessage={changeReplyMessage}
          handleReload={handleReload}
          isAudit={isAudit}
          isReplyMessage={isReplyMessage}
          setIsReplyMessage={setIsReplyMessage}
          handleFilesChange={handleFilesChange}
        />
      )}
    </>
  );
};

export default ChatBox;
